<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12">
                <FormInput label="Nombre" type="text" name="nombre" id="name" rules="required" v-model="promocion.name" />
            </div>
            <div class="col-12 col-lg-6">
                <FormInput
                    label="Descuento (%)"
                    name="Descuento (%)"
                    type="number"
                    v-model="promocion.discount_percent"
                    :disabled="hasFixedDiscount"
                />
            </div>
            <div class="col-12 col-lg-6">
                <FormInput
                    label="Descuento (€)"
                    name="Descuento (€)"
                    type="number"
                    v-model="promocion.discount_fixed"
                    :disabled="hasPercentDiscount"
                />
            </div>
            <div class="col-12">
                <div class="form-group">
                    <ValidationProvider name="evento anterior" rules="required" v-slot="{ errors }">
                        <label for="old_event">Seleccionar evento anterior</label>
                        <multiselect
                            v-model="promocion.old_event"
                            placeholder="Evento anterior"
                            label="nombre"
                            track-by="id"
                            :options="eventos"
                            :multiple="false"
                            :searchable="true"
                            :internal-search="true"
                            :max-height="130"
                        />
                        <span class="error invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12">
                <b-button type="submit" :disabled="!isFormValid">
                    Continuar
                </b-button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['promocion'],
        data() {
            return {
                eventos: []
            }
        },
        computed: {
            hasFixedDiscount() {
                const value = this.promocion.discount_fixed;
                return value != null && value !== '' && value !== 0 && value !== '0';
            },
            hasPercentDiscount() {
                const value = this.promocion.discount_percent;
                return value != null && value !== '' && value !== 0 && value !== '0';
            },
            isFormValid() {
                if (!this.promocion.name || this.promocion.name.trim() === '') {
                    return false;
                }
                if (!this.promocion.old_event) {
                    return false;
                }
                return this.hasFixedDiscount || this.hasPercentDiscount;
            }
        },
        created() {
            this.getEventos();
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    if(this.promocion.discount_fixed !== 0 && this.promocion.discount_fixed !== '' && this.promocion.discount_fixed != null){
                        this.promocion.discount_percent = 0;
                    } else {
                        this.promocion.discount_fixed = 0;
                    }
                    this.promocion.old_event_id = this.promocion.old_event.id;
                    this.$emit('terminado');
                }
            },
            getEventos() {
                this.promocion.filters = {};

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.promociones.eventos'), this.promocion).then(res => {
                    this.eventos = res.data.data;
                });
            }
        }
    }
</script>
